class StickyAddToCart extends HTMLElement {
    constructor() {
        super();


        this.layout_type = this.querySelector("sticky-add-to-cart-content").getAttribute("layout-type")


        this.drawerType = this.querySelector("[drawer-to-open]") ? this.querySelector("[drawer-to-open]").getAttribute("drawer-to-open") : "sticky-add-to-cart-drawer"


        this.variantList = this.querySelector("[sticky-add-to-cart-variants]");
        this.addToCartButton = this.querySelector("[add-to-cart-button]");

        document.addEventListener(_EVENT_HELPER.updateStickyAddToCartContent, this._updateStickyAddToCartContent.bind(this));
        document.addEventListener(_EVENT_HELPER.updateStickyAddToCartContentUnAvailable, this._updateStickyAddToCartContentUnAvailable.bind(this));

        // Listen for variant changes to re-copy quantity selector
        document.addEventListener('Variant:Changed', this._onVariantChange.bind(this));

        // Copy quantity selector on DOM load
        this._copyQuantitySelector();

        // Listen for screen size changes to re-sync quantity selectors
        window.addEventListener('resize', () => {
            this._setupQuantitySync();
        });

    }



    _copyQuantitySelector() {
        // Wait for DOM to be fully loaded
        if (document.readyState === 'loading') {
            document.addEventListener('DOMContentLoaded', () => this._copyQuantitySelectorContent());
        } else {
            this._copyQuantitySelectorContent();
        }
    }

    _copyQuantitySelectorContent() {
        const source = document.querySelector("[data-source]");
        const target = this.querySelector("[data-target]");
        const mobileTarget = document.querySelector("[data-mobile-target]");

        if (source && target) {
            target.innerHTML = source.innerHTML;
        }

        if (source && mobileTarget) {
            mobileTarget.innerHTML = source.innerHTML;
        }

        // Set up quantity sync for mobile screens
        this._setupQuantitySync();
    }

    _setupQuantitySync() {
        const source = document.querySelector("[data-source]");
        const target = this.querySelector("[data-target]");
        const mobileTarget = document.querySelector("[data-mobile-target]");
        
        if (!source) return;

        // Only sync on mobile screens (below 768px)
        const breakpoint = window.matchMedia('(max-width: 767px)');
        
        if (breakpoint.matches) {
            // Sync from source to target
            if (target) {
                this._syncQuantitySelectors(source, target);
            }
            
            // Sync from source to mobile target
            if (mobileTarget) {
                this._syncQuantitySelectors(source, mobileTarget);
            }
        } else {
            // On desktop, ensure target reflects source value
            if (target) {
                const sourceQuantityInput = source.querySelector('input[name="quantity"]');
                const targetQuantityInput = target.querySelector('input[name="quantity"]');
                if (sourceQuantityInput && targetQuantityInput) {
                    targetQuantityInput.value = sourceQuantityInput.value;
                }
            }
        }
    }

    _syncQuantitySelectors(source, target) {
        const sourceQuantityInput = source.querySelector('input[name="quantity"]');
        const targetQuantityInput = target.querySelector('input[name="quantity"]');
        const sourceIncrementBtn = source.querySelector('[increase-value]');
        const sourceDecrementBtn = source.querySelector('[decrease-value]');
        const targetIncrementBtn = target.querySelector('[increase-value]');
        const targetDecrementBtn = target.querySelector('[decrease-value]');
        
        if (sourceQuantityInput && targetQuantityInput) {
            // Listen for changes in source and update target
            sourceQuantityInput.addEventListener('change', () => {
                targetQuantityInput.value = sourceQuantityInput.value;
            });
            
            // Listen for changes in target and update source
            targetQuantityInput.addEventListener('change', () => {
                sourceQuantityInput.value = targetQuantityInput.value;
            });

            // Sync increment button clicks
            if (sourceIncrementBtn && targetIncrementBtn) {
                sourceIncrementBtn.addEventListener('click', () => {
                    setTimeout(() => {
                        targetQuantityInput.value = sourceQuantityInput.value;
                    }, 10);
                });
                
                targetIncrementBtn.addEventListener('click', () => {
                    setTimeout(() => {
                        sourceQuantityInput.value = targetQuantityInput.value;
                    }, 10);
                });
            }

            // Sync decrement button clicks
            if (sourceDecrementBtn && targetDecrementBtn) {
                sourceDecrementBtn.addEventListener('click', () => {
                    setTimeout(() => {
                        targetQuantityInput.value = sourceQuantityInput.value;
                    }, 10);
                });
                
                targetDecrementBtn.addEventListener('click', () => {
                    setTimeout(() => {
                        sourceQuantityInput.value = targetQuantityInput.value;
                    }, 10);
                });
            }
        }
    }

    _onVariantChange(e) {
        // Re-copy quantity selector content when variant changes
        setTimeout(() => {
            this._copyQuantitySelectorContent();
        }, 100); // Small delay to ensure DOM is updated
    }

    _updateStickyAddToCartContent(e) {
        let content_list = e.detail.sticky_content
        content_list.forEach(element => {

            let stickyElement = element.querySelector("sticky-add-to-cart-content")
            if (stickyElement.getAttribute("layout-type") === this.layout_type) {
                this.querySelector("[sticky-add-to-cart-content]").innerHTML = element.innerHTML
                // Re-copy quantity selector after content update
                setTimeout(() => {
                    this._copyQuantitySelectorContent();
                }, 50);
            }
        });

    }

    _updateStickyAddToCartContentUnAvailable(e) {
        this.variantList.textContent = e.detail.variantOptions.join(", ")
        this.togleAddToCartButton(false)
    }

    disconnectedCallback() {
        document.removeEventListener(_EVENT_HELPER.updateStickyAddToCartContent, this._updateStickyAddToCartContent.bind(this));
        document.removeEventListener('Variant:Changed', this._onVariantChange.bind(this));
        window.removeEventListener('resize', () => {
            this._setupQuantitySync();
        });
    }

    togleAddToCartButton(buttonEnabled) {
        if (this.addToCartButton) {
            if (buttonEnabled) {
                this.addToCartButton.removeAttribute("disabled")
            }
            else {
                if (!this.addToCartButton.classList.contains("sticky-icon-button")) {
                    this.addToCartButton.textContent = window.variantStrings.unavailable
                }
                this.addToCartButton.removeAttribute("form")
                this.addToCartButton.setAttribute("disabled", true);
            }
        }
    }


}
window.customElements.define('sticky-add-to-cart', StickyAddToCart);


class StickyAddToCartContent extends HTMLElement {
    constructor() {
        super();
        this.addToCartButton = this.querySelector("[add-to-cart-button]");
        this.buttonContainer = this.querySelector("[stikcy-add-to-cart-button-content]")
        this.addToCartButton?.addEventListener("click", (e) => {
            e.preventDefault();
            e.stopPropagation();
            this.handleStickyAddToCartClick();
        })
        this._product_container = document.querySelector('[product-container]');
        this._drawerScrollToSection = document.querySelector("drawer-component [scroll-to-section]")
        this._scrollToSectionButton = this.querySelector("[scroll-to-section]")
        this.breakpoint = window.matchMedia('(min-width:768px)');
        document.addEventListener(_EVENT_HELPER.resetStickyAddTocartButton, (e) => {
            HELPER_UTIL.submitButtonState(this.addToCartButton).resetState(
                1000
            );
            HELPER_UTIL.submitButtonState(this.addToCartButton).disableState(
                false
            );
        })

        // Reset button state when cart drawer is closed
        document.addEventListener(_EVENT_HELPER.hideDrawer, (e) => {
            if (e.detail.drawerType === 'cart-drawer') {
                setTimeout(() => {
                    HELPER_UTIL.submitButtonState(this.addToCartButton).resetState(0);
                    HELPER_UTIL.submitButtonState(this.addToCartButton).disableState(false);
                }, 100);
            }
        })

        // Reset button state when page becomes visible (user navigates back)
        document.addEventListener('visibilitychange', () => {
            if (!document.hidden) {
                setTimeout(() => {
                    HELPER_UTIL.submitButtonState(this.addToCartButton).resetState(0);
                    HELPER_UTIL.submitButtonState(this.addToCartButton).disableState(false);
                }, 100);
            }
        })

        document.addEventListener('scroll', this._scrollHandler.bind(this));
        window.addEventListener('resize', this.screenResize.bind(this));
        document.addEventListener(_EVENT_HELPER.triggerVariantAddToCartError, (e) => {
            this.componentState = this.closest("sticky-add-to-cart").getAttribute("aria-hidden")
            if (this.componentState === "false") {
                this._scrollToSection(e)
            }
        })
        this._scrollToSectionButton && this._scrollToSectionButton.addEventListener("click", this._scrollToSection.bind(this))
        this._drawerScrollToSection && this._drawerScrollToSection.addEventListener("click", this._scrollToSection.bind(this))
        this.scrollTosectionElement = this._scrollToSectionButton?.getAttribute("scroll-to-section") || this._drawerScrollToSection?.getAttribute("scroll-to-section")
    }

    handleStickyAddToCartClick() {
        const form = document.getElementById(this.addToCartButton.getAttribute('form'));
        if (!form) return;

        const formData = new FormData(form);
        
        // Show button loading state
        HELPER_UTIL.submitButtonState(this.addToCartButton).loadingState();
        
        // Add sections for cart drawer rendering
        formData.append(
            'sections',
            HELPER_UTIL.sectionRenderUtil('cart-drawer').getSectionsString()
        );

        // Get cart drawer element
        const cartDrawer = document.querySelector('drawer-cart');

        HELPER_UTIL.fetchData({
            method: 'POST',
            config: {
                headers: {
                    Accept: 'application/javascript',
                    'X-Requested-With': 'XMLHttpRequest',
                },
            },
            url: `${window.Shopify.routes.root}cart/add.js`,
            data: formData,
            onsuccess: (data) => {
                HELPER_UTIL.submitButtonState(this.addToCartButton).completeState();

                const offerButton =
                    document.querySelector(
                        'product-form [type="submit"][name="add"][data-offer-gift-variant], product-form [type="submit"][name="add"][data-discount-code], .ih-pdp-atc[data-offer-gift-variant], .ih-pdp-atc[data-discount-code]'
                    ) || this.addToCartButton;

                const finishAdd = (sections) => {
                    if (cartDrawer) {
                        window.currentActiveElement = this.addToCartButton;
                        HELPER_UTIL.dispatchCustomEvent(
                            _EVENT_HELPER.triggerCartChange,
                            this.addToCartButton,
                            {
                                productVariant: data.variant_id,
                                sections: sections || data.sections,
                                price: data.price,
                            }
                        );
                        if (HELPER_UTIL.stampCheckoutWithOfferDiscount) {
                            setTimeout(() => {
                                HELPER_UTIL.stampCheckoutWithOfferDiscount(
                                    document
                                );
                            }, 50);
                        }
                    } else {
                        window.location.href = `${window.Shopify.routes.root}cart`;
                    }
                };

                if (HELPER_UTIL.runOfferPostAdd) {
                    HELPER_UTIL.runOfferPostAdd(
                        offerButton,
                        data.sections,
                        finishAdd
                    );
                } else {
                    finishAdd(data.sections);
                }
            },
            onerror: (error) => {
                HELPER_UTIL.submitButtonState(this.addToCartButton).resetState(1000);
                HELPER_UTIL.dispatchCustomEvent(
                    _EVENT_HELPER.triggerVariantAddToCartError,
                    this.addToCartButton,
                    { error: error }
                );
            }
        });
    }

    connectedCallback() {
        this._product_containerOffsetTop = this._product_container?.offsetTop || 0;
        this._product_containerHeight = this._product_container?.offsetHeight || 0;
        this._earlyTrigger = this.closest('sticky-add-to-cart')?.hasAttribute('data-ih-sticky-early');
        this._totalScrollHeight = this._product_containerOffsetTop + this._product_containerHeight;
        if (this._earlyTrigger) {
            this._totalScrollHeight -= 200;
        }
        this._observeMainAtc();
        this.screenResize();
        
        // Ensure button starts in correct state
        setTimeout(() => {
            HELPER_UTIL.submitButtonState(this.addToCartButton).resetState(0);
            HELPER_UTIL.submitButtonState(this.addToCartButton).disableState(false);
        }, 100);
    }

    _setStickyActive(isActive) {
        const root = this.closest('sticky-add-to-cart');
        if (!root) return;
        root.classList.toggle('active', isActive);
        if (isActive) {
            setTimeout(() => {
                HELPER_UTIL.submitButtonState(this.addToCartButton).resetState(0);
                HELPER_UTIL.submitButtonState(this.addToCartButton).disableState(false);
            }, 100);
        }
    }

    _observeMainAtc() {
        if (!this._earlyTrigger || !('IntersectionObserver' in window)) return;
        const atc = document.querySelector('.main-product .product-form__buttons');
        if (!atc) return;

        this._usesAtcObserver = true;
        this._atcObserver = new IntersectionObserver((entries) => {
            const visible = entries.some((entry) => entry.isIntersecting);
            this._setStickyActive(!visible);
        }, { threshold: 0 });
        this._atcObserver.observe(atc);
    }

    _scrollToSection(e) {
        e.preventDefault()

        HELPER_UTIL.dispatchCustomEvent(_EVENT_HELPER.hideDrawer, this, {
            drawerType: this.drawerType,
        });
        window.scrollTo({
            top: this.scrollTosectionElementOffset,
            behavior: 'smooth'
        })
    }
    screenResize() {
        if (this.breakpoint.matches === true) {
            this.scrollTosectionElementOffset = document.querySelector(`[${this.scrollTosectionElement}]`)?.offsetTop

        } else {
            this.scrollTosectionElementOffset = document.querySelector(`[${this.scrollTosectionElement}]`)?.offsetTop + this._product_container.children[0].offsetHeight
        }
    }
    _scrollHandler() {
        if (this._usesAtcObserver) return;

        this._setStickyActive(window.scrollY > this._totalScrollHeight);
    }

    disconnectedCallback() {
        document.removeEventListener('scroll', this._scrollHandler.bind(this));
        this._scrollToSectionButton && this._scrollToSectionButton.removeEventListener("click", this._scrollToSection.bind(this))
        this._drawerScrollToSection && this._drawerScrollToSection.removeEventListener("click", this._scrollToSection.bind(this))
        if (this._atcObserver) {
            this._atcObserver.disconnect();
            this._atcObserver = null;
        }
    }
}

window.customElements.define('sticky-add-to-cart-content', StickyAddToCartContent);